export default __webpack_public_path__ + "static/media/bg7.8415b0ed.png";